import { API_URL, CHECKOUT_ENDPOINT } from "../helpers/constants";
import {
    bigCommerceApi,
    bigCommerceApiPost,
    bigCommerceApiPut,
} from "../helpers/fetchWrapper";

const checkoutBaseCurl = `${API_URL}/${process.env.BIGCOMMERCE_STORE_HASH}/${CHECKOUT_ENDPOINT}`;

export async function getCheckoutRest(cartId) {
    try {
        const getCheckoutUrl = `${checkoutBaseCurl}/${cartId}?include=consignments.available_shipping_options`;
        const data = await bigCommerceApi(getCheckoutUrl);
        return data;
    } catch (e) {
        return { error: e };
    }
}

export async function applyCouponCheckoutRest(checkoutId, couponCode) {
    try {
        const couponUrl = `${checkoutBaseCurl}/${checkoutId}/coupons`;
        const data = await bigCommerceApiPost(couponUrl, {
            coupon_code: couponCode,
        });
        return data;
    } catch (e) {
        return { error: e };
    }
}

export async function updateCheckoutConsignmentRest(
    checkoutId,
    consignmentId,
    payload
) {
    try {
        const updateConsignmentUrl = `${checkoutBaseCurl}/${checkoutId}/consignments/${consignmentId}`;
        const data = await bigCommerceApiPut(updateConsignmentUrl, {
            ...payload,
        });
        return data;
    } catch (e) {
        return { error: e };
    }
}

export async function updateCheckoutBillingAddressRest(
    checkoutId,
    addressId,
    payload
) {
    try {
        const updateConsignmentUrl = `${checkoutBaseCurl}/${checkoutId}/billing-address/${addressId}`;
        const data = await bigCommerceApiPut(updateConsignmentUrl, {
            ...payload,
        });
        return data;
    } catch (e) {
        return { error: e };
    }
}
